import axios from "axios";
import formatDate from "../../mixins/formatDate";
import CONSTANTS from "../../settings/constants";
import store from "../../store/index.js";

const getNews = (page, filter, itemsPerPage) => {
  if (!page || isNaN(page)) {
    page = 1;
  }

  let news = {
    total: 0,
    items: [],
  };

  let filters = filter.newsFilter;
  let personalisation = filter.newsPersonalisation;

  let allFilters = filters
    .filter((school) => school.id != "global")
    .map((school) => school.id);
  let allFiltersJoin = allFilters.join(",");

  let activeFilters = filters
    .filter((school) => school.value)
    .map((school) => school.id);

  let firstDayOfLastYear = formatDate(
    new Date(new Date().getFullYear() - 1, 0, 1)
  );
  let today = formatDate(Date.now());

  let newsApi = `${CONSTANTS.MIDDLEWARE}/articles?ids=${allFiltersJoin}&startDate=${firstDayOfLastYear}&endDate=${today}`;

  return new Promise(function(resolve) {
    if (activeFilters.length > 0) {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${newsApi}`);
      let start = Date.now();
      axios
        .get(newsApi)
        .then((response) => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${newsApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${newsApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          let filteredNews = response.data.filter((school) =>
            activeFilters.includes(school.id)
          );
          let personalisedNewsArticles = filteredNews.map((school) => {
            let tagFilter = personalisation.find(
              (filter) => filter.id === school.id
            );
            if (tagFilter) {
              let activeFilters = tagFilter.filters
                .filter((tag) => tag.value)
                .map((tag) => tag.id);

              return school.items.filter((news) => {
                if (news.tags) {
                  if (news.tags.includes("All") || news.tags.length === 0) {
                    return true;
                  } else {
                    return activeFilters.some((filter) =>
                      news.tags.includes(filter)
                    );
                  }
                } else {
                  return false;
                }
              });
            } else if (school.id === "global") {
              return school.items;
            } else {
              return [];
            }
          });

          // flatten the array of schools news into single array
          personalisedNewsArticles.forEach((schoolNews) => {
            news.items = [...news.items, ...schoolNews];
          });

          const now = new Date();

          news.items = news.items.filter((item) => {
            return new Date(item.created) <= now;
          });

          // sort news by date (newest to oldest)
          news.items = news.items.sort(function(a, b) {
            // pinned first to make sure featured always appears
            if (a.pinned) {
              return -1;
            }

            // newest to oldest
            if (new Date(a.created).getTime() > new Date(b.created).getTime()) {
              return -1;
            }
            if (new Date(a.created).getTime() < new Date(b.created).getTime()) {
              return 1;
            }

            // push global before other
            if (a.domain === "global") {
              return -1;
            } else {
              return 1;
            }
          });

          // assign total number of news for pagination and our spliced
          // selected based on itemsPerPage
          news.total = news.items.length;
          news.fullList = news.items;
          news.items = news.items.splice(0, page * itemsPerPage);
          news.initial = true;

          resolve(news);
        })
        .catch((error) => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${newsApi}: ${JSON.stringify(error, null, 2)}`
          );
        });
    } else {
      resolve(news);
    }
  });
};

const getIndividualNews = (id) => {
  let individualNewsApi = `${CONSTANTS.MIDDLEWARE}/news-article?id=${id}`;

  return new Promise(function(resolve) {
    let article = store.getters.news.fullList.find(
      (article) => article.id === id
    );

    if (article) {
      resolve(article);
    } else {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${individualNewsApi}`);
      let start = Date.now();
      axios
        .get(individualNewsApi)
        .then((response) => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualNewsApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualNewsApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          resolve(response.data);
        })
        .catch((error) => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${individualNewsApi}: ${JSON.stringify(
              error,
              null,
              2
            )}`
          );
        });
    }
  });
};

export default { getNews, getIndividualNews };
